import { BaseWebUrl } from '@/utils/request/baseWebUrl'
import { API_ENDPOINTS } from '@/config/apiEndpoints'
import type {
  PublishRawTagList,
} from '@/publish/types'

type JsonRecord = Record<string, unknown>
type RequestTraceStatus = 'running' | 'done' | 'error'
type RequestTraceCallback = (status: RequestTraceStatus, detail: string) => void

const webUrl = new BaseWebUrl()
const cgEndpoints = API_ENDPOINTS.cg

function stringifyTagField(value: unknown): string {
  if (typeof value === 'string') return value
  if (Array.isArray(value)) return JSON.stringify(value)
  return JSON.stringify([])
}

function buildRawTagQuery(params: {
  uid: number
  sessionId: string
  gindex: string
  guid: string
  screenType: number
  payType: number
  tagList: PublishRawTagList
}): URLSearchParams {
  return new URLSearchParams({
    uid: String(params.uid),
    sessionid: params.sessionId,
    gindex: params.gindex,
    guid: params.guid,
    channel_id: String(params.tagList.channel_id ?? 0),
    screen_type: String(params.screenType),
    m_source: String(params.tagList.m_source ?? 10),
    pay_type: String(params.payType),
    show_tag: stringifyTagField(params.tagList.show_tag),
    wait_show_tag: stringifyTagField(params.tagList.wait_show_tag),
    remaind_tag: stringifyTagField(params.tagList.remaind_tag),
    hide_tag: stringifyTagField(params.tagList.hide_tag),
    invalid_tag: stringifyTagField(params.tagList.invalid_tag),
    question_list: stringifyTagField(params.tagList.question_list),
    role_list: stringifyTagField(params.tagList.role_list),
    role_partition: String(params.tagList.role_partition || ''),
  })
}

export async function submitGameTags(params: {
  uid: number
  sessionId: string
  gindex: string
  guid: string
  screenType: number
  payType: number
  tagList: PublishRawTagList
}, onTrace?: RequestTraceCallback): Promise<JsonRecord> {
  const url = `${webUrl.baseCg.replace(/\/$/, '')}${cgEndpoints.submitGameTags}`
  const query = buildRawTagQuery(params)
  const traceLabel = `GET ${cgEndpoints.submitGameTags}`
  onTrace?.('running', `${traceLabel} · start`)
  const res = await fetch(`${url}?${query.toString()}`, {
    method: 'GET',
    credentials: 'include',
  })
  if (!res.ok) {
    onTrace?.('error', `${traceLabel} · HTTP ${res.status}`)
    throw new Error(`提交标签失败：HTTP ${res.status}`)
  }
  const data = (await res.json()) as JsonRecord
  if (Number(data.ret ?? data.status ?? 0) !== 1) {
    onTrace?.('error', `${traceLabel} · ${String(data.msg ?? '提交标签失败')}`)
    throw new Error(String(data.msg ?? '提交标签失败'))
  }
  onTrace?.('done', `${traceLabel} · done · ret=${String(data.ret ?? data.status ?? 1)}`)
  return data
}
